module.exports = __webpack_public_path__ + "img/icon-linux.6a8ec8f2.svg";